<div class="drawer__tabs">
    @for (tab of tabs(); track tab) {
        <button
            type="button"
            class="drawer__tabs__item btn btn-ghost btn-icon"
            siTooltip="{{ tab.name | translate }}"
            placement="start"
            [attr.aria-label]="tab.name | translate"
            [class.active]="selectedTab() === tab.id"
            (click)="tabChanged(tab.id)"
        >
            <si-icon [icon]="tab.icon"></si-icon>
        </button>
    }
</div>
<div class="drawer__content">
    <div class="bar-container">
        @if (loading()) {
            <si-loading-spinner [ariaLabel]="'accessibility.loading-drawer' | translate" />
        }
    </div>
    @if (!loading()) {
        @if (selectedTab() === 1 && focusedLocation(); as focusedLocationValue) {
            <app-tab-location-info [location]="focusedLocationValue"></app-tab-location-info>
        }
        @if (selectedTab() === 2 && focusedLocation(); as focusedLocationValue) {
            <app-tab-communication [location]="focusedLocationValue"></app-tab-communication>
        }
        @if (selectedTab() === 3 && focusedCountry(); as focusedCountryValue) {
            <app-tab-country-info [country]="focusedCountryValue"></app-tab-country-info>
        }
        @if (selectedTab() === 4 && focusedLocation(); as focusedLocationValue) {
            <app-tab-directions [gps]="focusedLocationValue.gps"></app-tab-directions>
        }
        @if (selectedTab() === 5 && focusedLocation(); as focusedLocationValue) {
            <app-tab-downloads [location]="focusedLocationValue"></app-tab-downloads>
        }
        @if (selectedTab() === 6 && focusedLocation(); as focusedLocationValue) {
            <app-tab-person [location]="focusedLocationValue" [userDetail]="userDetail()"></app-tab-person>
        }
    }
</div>
